import AppLogResourcePagingResultModel from '../../generated/types/model/resource/AppLogResourcePagingResultModel';

export default class AppLogResourcePagingResultViewModel extends AppLogResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
